import classNames from "classnames";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import {
  ReactNode, useEffect, useRef, useState,
} from "react";
import styles from "./readMore.module.scss";

interface IProps {
  text: string | ReactNode;
  lineClamp: number;
}

function ReadMore(props: IProps) {
  const { text, lineClamp = 3 } = props;
  const ref = useRef<HTMLParagraphElement>(null);
  const [showReadMore, setShowReadMore] = useState(true);
  const [isCropped, setIsCropped] = useState(false);
  const router = useRouter();
  const { t } = useTranslation("common");

  useEffect(() => {
    // Determines if text exceeds lineClamp, will show Read More if so
    if (ref.current && ref.current.scrollHeight > ref.current.clientHeight) {
      setIsCropped(true);
    } else {
      setIsCropped(false);
    }
  }, []);

  useEffect(() => {
    // Reset read more state on route change
    setShowReadMore(true);
  }, [router.asPath]);

  const style = {
    WebkitLineClamp: showReadMore ? lineClamp : "inherit",
  };

  return (
    <div className={styles.container}>
      <div>
        <p
          className={styles.text}
          style={style}
          ref={ref}
        >
          {text}
        </p>

        <span
          onClick={() => setShowReadMore(!showReadMore)}
          className={classNames(styles.read_more, {
            [styles.show_read_more]: isCropped,
            [styles.expanded]: !showReadMore,
          })}
        >
          {showReadMore ? t("Read More") : t("Read Less")}
        </span>

      </div>
    </div>
  );
}

export default ReadMore;
